<app-layout [isProducerArea]="true">
  <app-page-header
    title="Editar evento"
    titleIcon="pi pi-edit"
    subtitle="
      Preencha as etapas para configurar seu evento e garantir uma experiência incrível para os participantes.
    "
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      {
        label: 'Editar evento',
        icon: 'pi pi-edit',
      },
    ]" />
  <div class="p-4">
    <app-event-form [eventId]="id ?? undefined" />
  </div>
</app-layout>
